module.exports = __webpack_public_path__ + "static/media/Baskervald-01.cc45cf3e.svg";